module.exports = __webpack_public_path__ + "img/quxiao.7f8104ed.png";